module.exports = __webpack_public_path__ + "img/stickers_0017_3K.23c99a41.png";